import { ROOT_CLEAR } from './type'
export const CLEAR: ROOT_CLEAR = 'ROOT_CLEAR'
